import "./ToolTipComponent.scss";
import React, {ReactFragment, useCallback} from "react";
import {Tooltip} from "@mui/material";

interface ToolTipComponentProps {
    tooltip: any | ReactFragment;
    showArrow?: boolean;
    position?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top';
    onOpen?: () => void;
    onClose?: () => void;
    showAfter?: number;
    hideAfter?: number;
    isFormTooltip?: boolean
}

const ToolTipBgColor = "#D0FFF5";

const ToolTipComponent = (props: React.PropsWithChildren<ToolTipComponentProps>) => {

    const {isFormTooltip, tooltip, showArrow, showAfter, hideAfter, onOpen, onClose, children} = props;

    const position = props.position || "top";

    const handleOpen = useCallback((e: any) => {
        if (onOpen) {
            onOpen();
        }
    }, [onOpen]);

    const handleClose = useCallback((e: any) => {
        if (onClose) {
            onClose();
        }
    }, [onClose]);

    return (
        <Tooltip title={
            <React.Fragment>
                {tooltip}
            </React.Fragment>
        }
                 arrow={showArrow}
                 placement={position}
                 onOpen={handleOpen}
                 onClose={handleClose}
                 enterDelay={showAfter}
                 leaveDelay={hideAfter}
                 componentsProps={{
                     tooltip: {
                         sx: isFormTooltip
                             ? { // If condition is true, apply this style
                                 fontSize: '12px',
                                 fontFamily: 'Roboto, sans-serif',
                                 padding: '12px 16px',
                                 fontWeight: 400,
                                 borderRadius: '10px',
                                 border: '1px solid #BFC6CD',
                                 bgcolor: '#E3F4FE',
                                 color: '#07213C',
                                 '& .MuiTooltip-arrow': {
                                     color: "#E3F4FE",
                                     "&:before": {
                                         content: '""',
                                         display: 'block',
                                         width: '100%',
                                         height: '100%',
                                         border: '1px solid #BFC6CD', // Border for the arrow
                                         backgroundColor: '#E3F4FE',
                                     },
                                 },
                             }
                             : { // Default style
                                 fontSize: '12px',
                                 fontFamily: 'Inter, sans-serif',
                                 padding: '10px',
                                 fontWeight: 400,
                                 borderRadius: '6px',
                                 border: '1px solid #66FFE0',
                                 bgcolor: ToolTipBgColor,
                                 color: '#07213C',
                                 '& .MuiTooltip-arrow': {
                                     color: "#66FFE0",
                                     "&:before": {
                                         border: "none"
                                     },
                                 },
                             }
                     }
                 }}

        >
            {children}
        </Tooltip>
    );

};

export default ToolTipComponent;

// ****************************** USAGE ****************************** //

// <ToolTipComponent tooltip={serviceCategory?.name || "-"}
//                   position={"top"}
//                   onOpen={()=>{
//                       console.log("tooltip opened");
//                   }}
//                   onClose={()=>{
//                       console.log("tooltip CLOSED");
//                   }}
// >
//     <div className="service-category-name" id={`sc_${serviceCategory?.name}`}>
//         {serviceCategory?.name || "-"}
//     </div>
// </ToolTipComponent>

// ****************************** USAGE ****************************** //
